import { ICommand, IDefineCommand } from 'core-ts-types';
import { INotificationDelegate } from '../../global/helpers/notification_delegate';
import { RouterHelper } from '../../global/helpers/router_helper';
import { AdvisorHeaderDetailsQuery } from '../../suggestions/components/plan_feedback/queries/advisor_plan_details_query';
import { PlanFeedbackServant } from '../../suggestions/components/plan_feedback/servants/plan_feedback_servant';

angular
  .module('capability-ng-academic-planner')
  .service(
    'navigateIfPlanBlockedCommand',
    (
      loadSuggestedPlanStatusCommand: ICommand,
      ngAPAdvisorHeaderDetailsQuery: AdvisorHeaderDetailsQuery,
      ngAPNotificationDelegate: INotificationDelegate,
      defineCommandORM: IDefineCommand,
      routerHelper: RouterHelper
    ) => {
      return defineCommandORM('navigateIfPlanBlockedCommand', (deferred) => {
        loadSuggestedPlanStatusCommand().then(() => {
          let gotoState;
          const isPlanTurnedBlocked = PlanFeedbackServant.isPlanBlocked(ngAPAdvisorHeaderDetailsQuery.result);
          if (isPlanTurnedBlocked) {
            const defaultTimeout = 4000;
            ngAPNotificationDelegate.info({
              content: `Plan got blocked, navigating to retain suggestions`,
              timeout: defaultTimeout
            });
            gotoState = 'ap-advisor.retain_suggestions.blocked_suggestions';
          }
          return routerHelper.navigateFromRouter(deferred, gotoState);
        });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/routes/re_route_strategies/navigate_if_plan_blocked_command.ts